import { render, staticRenderFns } from "./SystemComponentsHierarchyInfo.vue?vue&type=template&id=e98496c6&"
import script from "./SystemComponentsHierarchyInfo.vue?vue&type=script&lang=js&"
export * from "./SystemComponentsHierarchyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports